export default "__VITE_ASSET__DL$29Qa0__"